import { render } from "./TabPlantDetailsInfo.vue?vue&type=template&id=683dc52a&scoped=true"
import script from "./TabPlantDetailsInfo.vue?vue&type=script&lang=js"
export * from "./TabPlantDetailsInfo.vue?vue&type=script&lang=js"

import "./TabPlantDetailsInfo.vue?vue&type=style&index=0&id=683dc52a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683dc52a"]])

export default __exports__